import { BO, BusinessObjectBase, Weaver } from '@skylab-shared/core';
import { UserModel, UserPermissionKind } from '@skylab-shared/dataModel';
import { LoggedUserQuery } from './queries/logged-user.query-base';
import { UserRoleQuery } from './queries/user-role.query-base';

@BO({ modelType: UserModel })
export class UserBO extends BusinessObjectBase<UserModel> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        await Promise.resolve([
            this.localContext.preload(LoggedUserQuery),
            this.localContext.preload(UserRoleQuery)
        ]);

        this.configureReadonlyRules();
    }

    private configureReadonlyRules(): void {
        this.readonly.addRule(
            [[UserModel, 'userPermissionKinds']],
            _ => !!this.localContext.firstPreloaded(UserRoleQuery, {id: this.model.roleId})?.permissionKinds.includes(UserPermissionKind.PermissionsConfiguration)
        );

        this.readonly.addRule(
            [[UserModel, 'roleId']],
            _ => this.model.id === this.localContext.getPreloaded(LoggedUserQuery)?.id
        );
    }
}
